// A dead sign-in must drop the saved token. A storage or network hiccup
// must not, or a deploy blip would log everyone out.
function sessionCheckResult(status, body) {
  if (status === 401) return 'logout';
  if (status === 200 && body && body.success === false) return 'logout';
  return 'keep';
}

module.exports = sessionCheckResult;
